module.exports = __webpack_public_path__ + "img/icon_linkedin.9b60bf1b.png";